import { render } from "./WeekCycle.vue?vue&type=template&id=28d5d812"
import script from "./WeekCycle.vue?vue&type=script&lang=js"
export * from "./WeekCycle.vue?vue&type=script&lang=js"

import "./WeekCycle.vue?vue&type=style&index=0&id=28d5d812&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__